import { useAsyncQuery } from '@client/new/helpers/gql';
import {
  useGetProgramWithChallengesQuery,
  useUpdateSubmissionMutation,
} from 'generated/graphql';
import {
  ServerProgramWithChallenge,
  toChallenge,
  toSubmissionsURL,
} from './Challenges.mapper';
import { Challenge } from './Challenges.types';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { Async, SMap, toAsyncFetched } from '@client/new/helpers/types';
import { SalesType } from '../../collection/domain';
import { getType } from '../../collection/useLiteProgram';
import { useState } from 'react';

export type ChallengeDetailsModelData = Challenge & {
  name: string;
  programId: number;
  programName: string;
  programType: SalesType;
  creatorId: number;
};

export type UseChallengeDetailsParams = {
  programId: number;
  challengeId: string;
};

type ChallengeDetailsModelActions = {
  toggleFav: (p: { submissionId: string; isFav: boolean }) => Promise<unknown>;
};
export type ChallengeDetailsModel = ChallengeDetailsModelData &
  ChallengeDetailsModelActions;
export const useChallengeDetailsModel = (
  args: UseChallengeDetailsParams,
): Async<ChallengeDetailsModel> => {
  const creatorId = useInfluencerId();
  const [favMap, setFavMap] = useState<SMap<boolean>>({});
  const res = useGetProgramWithChallengesQuery({
    variables: { collectionId: args.programId },
    // TODO [G]: add challengeId to the query when BE is ready
    // challenges(where: { id: $challengeId })
  });

  const [updateSubmission] = useUpdateSubmissionMutation();

  const { data } = useAsyncQuery(
    res,
    'collection',
    toChallengesModel({ challengeId: args.challengeId, creatorId }),
  );

  const toggleFav = (p: { submissionId: string; isFav: boolean }) => {
    setFavMap((prev) => ({ ...prev, [p.submissionId]: p.isFav }));
    return updateSubmission({
      variables: {
        submissionId: parseInt(p.submissionId, 10),
        isShortlisted: p.isFav,
      },
    });
  };

  if (data.type !== 'fetched') return data;
  const submissions = data.value.submissions.map((s) => ({
    ...s,
    isFav:
      favMap[s.submissionId] !== undefined ? favMap[s.submissionId] : s.isFav,
  }));
  return toAsyncFetched({ ...data.value, submissions, toggleFav });
};

const toChallengesModel =
  (args: { challengeId: string; creatorId: number }) =>
  (p: ServerProgramWithChallenge): ChallengeDetailsModelData => {
    const serverChallenge = (p.challenges || []).find(
      (c) => c && c.id == args.challengeId,
    );
    if (!serverChallenge) throw new Error('Challenge not found');
    console.log('submissions!', serverChallenge.submissions);
    const challenge = toChallenge(
      toSubmissionsURL({ creatorId: args.creatorId, programId: p.id }),
    )(serverChallenge);
    return {
      creatorId: args.creatorId,
      programName: p.name || '',
      programType: getType(p.accessType),
      programId: p.id,
      ...challenge,
    };
  };
